<template>
  <section class="projects padding sectionScroll" id="sectionScroll3">
    <div class="container">
      <div class="row">
        <div class="col-8 animation a-translateY">
          <a class="col-8__body" href="#">
            <h3 v-if="HEADER_LANG === 'en'">D.C. Housing Authority</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Управление жилищного строительства округа Колумбия</h3>
            <picture>
              <source srcset="../../public/static/images/home/8.webp">
              <img src="../../public/static/images/home/8.jpg" alt="">
            </picture>
          </a>
        </div>
        <div class="col-4 red animation a-translateY a-tr-1">
          <div class="col-4__body">
            <h2 v-if="HEADER_LANG === 'en'">Our Projects</h2>
            <h2 v-if="HEADER_LANG === 'ru'">Наши проекты</h2>
            <button class="button">See All</button>
          </div>
        </div>
        <div class="col-4 animation a-translateY">
          <a class="col-4__body" href="#">
            <h3 v-if="HEADER_LANG === 'en'">Phyllis Wheatley YWCA</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Филлис Уитли YWCA</h3>
            <picture>
              <source srcset="../../public/static/images/home/9.webp">
              <img src="../../public/static/images/home/9.jpg" alt="">
            </picture>
          </a>
        </div>
        <div class="col-4 animation a-translateY a-tr-1">
          <a class="col-4__body" href="#">
            <h3 v-if="HEADER_LANG === 'en'">Elsie Whitlow Stokes</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Элси Уитлоу Стоукс</h3>
            <picture>
              <source srcset="../../public/static/images/home/10.webp">
              <img src="../../public/static/images/home/10.jpg" alt="">
            </picture>
          </a>
        </div>
        <div class="col-4 animation a-translateY a-tr-2">
          <a class="col-4__body" href="#">
            <h3 v-if="HEADER_LANG === 'en'">MARTA Project</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Проект МАРТА</h3>
            <picture>
              <source srcset="../../public/static/images/home/11.webp">
              <img src="../../public/static/images/home/11.jpg" alt="">
            </picture>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionProjects',
  components: {},
  methods: {},
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.projects {
  background-color: $cBlack;
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex: 0 0 auto;
    margin-bottom: 0 -10px;
    height: auto;
    position: relative;
    .col-4 {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 10px;
      overflow: hidden;
      margin-bottom: 20px;
      &__body {
        box-sizing: border-box;
        position: relative;
        max-width: 100%;
        width: 100%;
        height: 100%;
        transition: .1s linear all;
        &:after {
          transition: .1s linear all;
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: $cBlack;
          opacity: 0;
        }
        &:hover {
          &:after {
            opacity: .8;
          }
        }
        &:active {
          opacity: .6;
        }
      }
      &.red {
        .col-4__body {
          background-color: $cBlack;
          border: 10px solid $cRed;
          color: $cWhite;
          padding: 20px;
          text-align: end;
          &:after {
            display: none;
          }
          h2 {
            padding-bottom: 20px !important;
            &:after {
              background-color: $cYellow;
              width: 100%;
            }
          }
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      h3 {
        color: $cWhite;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: $cBlack;
        max-width: 270px;
        padding: 28px 28px 10px 0;
      }
      @media (max-width: 1199.98px) {
        flex: 0 0 50%;
        max-width: 50%;
      }
      @media (max-width: 767.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        img {
          max-height: 200px;
        }
        h3 {
          max-width: 230px;
          padding: 14px 14px 5px 0;
        }
      }
    }
    .col-8 {
      flex: 0 0 66.666%;
      max-width: 66.666%;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 10px;
      overflow: hidden;
      margin-bottom: 20px;
      &__body {
        box-sizing: border-box;
        position: relative;
        max-width: 100%;
        width: 100%;
        height: 100%;
        transition: .1s linear all;
        &:after {
          transition: .1s linear all;
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: $cBlack;
          opacity: 0;
        }
        &:hover {
          &:after {
            opacity: .8;
          }
        }
        &:active {
          opacity: .6;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      h3 {
        color: $cWhite;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: $cBlack;
        max-width: 270px;
        padding: 28px 28px 10px 0;
      }
      @media (max-width: 1199.98px) {
        flex: 0 0 50%;
        max-width: 50%;
      }
      @media (max-width: 767.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        img {
          max-height: 200px;
        }
        h3 {
          max-width: 230px;
          padding: 14px 14px 5px 0;
        }
      }
    }
  }
}
@media (max-width: 1199.98px) {
  .col-4:last-child {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    img {
      max-height: 340px;
    }
  }
}
</style>
